<template>
<div>
<App-navigation></App-navigation>
     
    <v-container grid-list-lg>

        <v-layout row>
            <v-flex  class="text-xs-center display-1 font-weight-black ">Available Campuses </v-flex>
            <v-text-field
              prepend-icon="search"
              append-icon="mic"
              label="Search"
              solo-inverted
              class="mx-2"
              flat

            ></v-text-field>
            
        </v-layout>
        <v-layout row wrap>
            <v-flex class="text-xs-center display-3 font-weight-black my-5" v-if="specific()[0] == null">
             
                Welcome {{ staff.gender == 'male' ? 'Mr.' : 'Miss.' }} {{staff.fullname.toUpperCase()}},
                 there are no stored campuses yet
                <br><br>
                <h4>You may also be seeing this message if a campus you work in has been deleted</h4>
            </v-flex>
            <v-flex xs12 sm12 md4 v-for="(item, index) in specific()"  :key="index">
                <v-card >
                  
                    <v-img :src="item.image"   height="300px" @click="next(item.name)" title="View">
                        <v-container fill-height fluid>
                            <v-layout fill-height>
                                <v-flex xs12 align-end flexbox>
                                    <span class="headline white--text" ><b></b></span>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-img>

                    <v-card-title primary-title>
                        <div>
                            <h3 class="headline mb-0 "><b>{{item.name.toUpperCase()}}</b></h3>
                            <edit-campus :name="item.name" :movies="item.movies" v-if="crc(staff.rights,'017')"></edit-campus>
                            <delete-campus :name="item.name" v-if="crc(staff.rights,'018')"></delete-campus>
                        </div>
                    </v-card-title>
                </v-card>
            
            </v-flex>
                </v-layout>
            
<Add-campus v-if="crc(staff.rights,'016')"></Add-campus>
    </v-container>
</div>
</template>

<script>
import AddCampus from '@/components/Campus/AddCampus.vue'
import EditCampus from '@/components/Campus/EditCampus.vue'
import DeleteCampus from '@/components/Campus/DeleteCampus.vue'
import AppNavigation from '@/components/Navigation/AppNavigation.vue'

import {checkright,specify} from '@/validator'

/*

*/
export default {
    name: 'Campus',
    components: {
      AddCampus,
      EditCampus,
      DeleteCampus,
      AppNavigation
    },
    data() {
        return {
            appTitle: 'Exodus',
            staff:this.$store.getters.getStaff,
            drawer: true,
            
                    };
    },
   

    methods:{
      
      //This method is used for assigning rights-based functionality
      crc(array,value){
      return checkright(array,value);
    },
        next(value){
            this.$router.push({ name:'campus-movie', params:{campus:value}});
        },
        specific(){
        if(this.$store.getters.getStaff.campus == 'all'){
                return this.loads();
     
        }else{
                return specify(this.loads(),'name',this.$store.getters.getStaff.campus);
     
        }
        },
        loads(){
           
            let self=this;
            let value;
            self.$store.dispatch('updateCampus',false);
            value = self.$store.getters.getCampus;
            return value;
           
            
        }
    }
};
</script>

<style scoped>
.fab-container{
    position:fixed;
    
    bottom:0;
    right:0
}
</style>